import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62494553"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_member_title = _resolveComponent("app-member-title")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer" }, {
    title: _withCtx(() => [
      _createVNode(_component_app_member_title, { routes: _ctx.routes }, null, 8, ["routes"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "userCode",
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData,
          "show-pagination": true
        }, {
          action: _withCtx(({ record }) => [
            _createElementVNode("a", {
              href: "#",
              onClick: _withModifiers(($event: any) => (_ctx.operate('execute', record)), ["prevent"])
            }, "执行", 8, _hoisted_1),
            _hoisted_2,
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _withModifiers(($event: any) => (_ctx.operate('edit', record)), ["prevent"])
            }, "编辑", 8, _hoisted_3),
            _hoisted_4,
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _withModifiers(($event: any) => (_ctx.operate('log', record)), ["prevent"])
            }, "执行记录", 8, _hoisted_5),
            _hoisted_6,
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _withModifiers(($event: any) => (_ctx.operate('delete', record)), ["prevent"])
            }, "删除", 8, _hoisted_7)
          ]),
          _: 1
        }, 8, ["columns", "data"])
      ])
    ]),
    _: 1
  }))
}